<template>

  <tr>
    <td class="hidden-xs">
      <!-- #todo - used for merging, or mass edit -->
  <!--                       <div class="be-checkbox be-checkbox-sm">
        <input id="check2" type="checkbox">
        <label for="check2"></label>
      </div> -->
    </td>

    <td class="cell-detail" v-bind:class="{editingTitle}">

      <form v-if="editingTitle" v-on:submit.prevent="finishEditingTitle">
        <div class="input-group input-group-sm">
          <input
            v-model="newTitle"
            v-focus
            v-on:keyup.esc="cancelEditingTitle"
            v-on-click-away="cancelEditingTitle"
            type="text"
            class="form-control input-sm">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-primary">Save</button>
          </span>
        </div>

      </form><!-- end if editing -->

      <!-- Non-edit mode -->
      <div v-else>
        <span v-on:dblclick="startEditingTitle">
          {{chapter.title}}
          <!-- #todo - show number of new micro notes? -->
          <!-- <span style="display: inline;" class="badge badge-success">2</span> -->
        </span>
        <span class="cell-detail-description">
          {{activeMicroNoteCount || 0}}
          Micro Note{{(activeMicroNoteCount || 0) === 1 ? '' : 's'}}
        </span>
      </div><!-- end non-edit mode -->
    </td>

    <td v-if="studyProgressPercent === 100" class="milestone">
      <span class="completed">{{studyProgressPercent}}%</span>
      <span class="version">Complete!</span>
      <div class="progress">
        <div :style="'width: ' + studyProgressPercent + '%'" class="progress-bar progress-bar-success"></div>
      </div>
    </td>

    <td v-else class="milestone">
      <span class="completed">{{studyProgressPercent}}%</span>
      <span class="version">{{unstudiedMicroNotesCount}} remaining</span>
      <div class="progress">
        <div :style="'width: ' + studyProgressPercent + '%'" class="progress-bar progress-bar-primary"></div>
      </div>
    </td>

    <td  class="hidden-xs"><!-- space --></td>

    <td class="cell-detail hidden-xs">
      <small>{{friendlyLastStudiedAt}}</small>
      <!-- <span class="cell-detail-description">8:30</span> -->
    </td>

    <td class="text-right">
      <div class="btn-group btn-hspace">
        <router-link :to="{name: 'chapter-studier', params: {chapterId: chapter.id}}" v-if="chapter.micro_notes_count && studyProgressPercent < 100" class="btn btn-primary"><i class="icon mdi mdi-play-circle-outline"></i> Study</router-link>
        <button type="button" data-toggle="dropdown" class="btn btn-default dropdown-toggle" v-if="showActions">Actions <span class="icon-dropdown mdi mdi-chevron-down"></span></button>
        <ul role="menu" class="dropdown-menu pull-right" v-if="showActions">

          <li v-if="chapter.micro_notes_count"><router-link :to="{name: 'micro-note-editor', params: {chapterId: chapter.id}}" class="tooltip-custom">
            Edit Micro Notes
             <div class="popup">
                Edit existing micronotes
             </div>
             <div class="carret"></div>
          </router-link></li>
          <li><router-link :to="{name: 'micro-note-creator', params: {chapterId: chapter.id}}" class="tooltip-custom">
            Create Micro Notes
            <div class="popup">Create additional micro notes<br />from imported lecture note</div>
            <div class="carret"></div>
          </router-link></li>

          <li class="divider"></li>
          <li><router-link :to="{name: 'share-chapter', params: {chapterId: chapter.id}}">Share</router-link></li>
          <li><a href @click.prevent="exportChapter(chapter)">Export</a></li>
          <li><a href @click.prevent="deleteChapter(chapter)">Delete</a></li>
        </ul>
      </div>
    </td>

    <!-- <td>&nbsp;</td> -->

  </tr>

</template>

<script>
import _ from 'underscore'
import { mapState, mapActions } from 'vuex'
import { directive as onClickAway } from 'vue-clickaway'
import moment from 'moment-timezone'

export default {
  props: ['chapter'],
  methods: {
    deleteChapter(chapter) {
      // if( !confirm(`Are you sure you want to delete ${chapter.title}?`)) return;
      this.$store.dispatch('deleteChapter', {chapter})
    },

    exportChapter(chapter) {
      this.$store.dispatch('exportMicroNotes', { fileName: chapter.title, export: { chapter_ids: chapter.id.toString() } })
    },

    shareChapter(chapter) {
      this.$store.dispatch('exportMicroNotes', { fileName: chapter.title, export: { chapter_ids: chapter.id.toString() } })
    },

    startEditingTitle() {
      if (this.showActions) {
        this.newTitle = this.chapter.title;
        this.editingTitle = true;
      }
    },
    cancelEditingTitle() {
      // this.newTitle = ''; // clickaway happens before finishEditingTitle
      this.editingTitle = false;
    },
    finishEditingTitle() {
      const _this = this;
      const changes = { title: this.newTitle };
      this.$store.dispatch('updateChapter', { id: this.chapter.id, changes }).then(() => {
        _this.editingTitle = false;
        _this.newTitle = '';
      });
    },
    
  },

    computed: {
      ...mapState([
        'currentUser',
      ]),

    friendlyLastStudiedAt() {
      if( !this.chapter.last_studied_at) return 'Never';
      return moment(this.chapter.last_studied_at).fromNow();
    },

    studyProgressPercent() {
      if (this.activeMicroNoteCount <= 0) {
        return 0;
      }
      return Math.round((this.activeMicroNoteCount - this.unstudiedMicroNotesCount) / this.activeMicroNoteCount * 100);
    },
    unstudiedMicroNotesCount() {
      if( !this.chapter.micro_notes_count) return 0;
      let unstudiedMicroNotes = this.$store.getters.unstudiedMicroNotes;
      unstudiedMicroNotes = _.where(unstudiedMicroNotes, {chapter_id: this.chapter.id})
      return _.isArray(unstudiedMicroNotes) ? unstudiedMicroNotes.length : 0;
      },
      activeMicroNoteCount() {
        if (!this.chapter.micro_notes_count) return 0;
        let activeMicroNotes = this.$store.getters.activeMicroNotes;
        activeMicroNotes = _.where(activeMicroNotes, { chapter_id: this.chapter.id })
        return _.isArray(activeMicroNotes) ? activeMicroNotes.length : 0;
      },
      showActions() {
        return this.currentUser.role !== 'student';
      },
    },



  data() {
    return {
      editingTitle: false,
      newTitle: '',
    }
  },
  directives: {
    onClickAway,
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function (el) {
        // Focus the element
        el.focus();
      }
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
td.editingTitle {
  padding-left: 0;
}

  .tooltip-custom { position: relative; }
  .tooltip-custom .popup { position: absolute; right: 100%; top: 0px; background: #206ff2; color:#FFFFFF; display: none; padding:8px 10px;}
  .tooltip-custom .carret {display:none; position: absolute; right: 100%; top: 8px; margin-right: -12px; width: 0; height: 0; border-top: 10px solid transparent; border-bottom: 10px solid transparent; border-left: 12px solid #206ff2; }
  .tooltip-custom:hover  .popup{display:block;}
  .tooltip-custom:hover .carret { display: block; }
</style>



// WEBPACK FOOTER //
// SubjectShelfChapterRow.vue?a56ac9e2